module.exports = __webpack_public_path__ + "img/renta-por-horas.png";